module.exports = __webpack_public_path__ + "static/strendingur_logo-04be639b097d2f703efe5708858dee56.png";